export default [
  {
    path: 'operations',
    name: 'operations',
    component: () => import('@/views/operations/Wrapper'),
    children: [
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/operations/MessageSearchWrapper.vue'),
      },
      {
        path: '/operations/calendar',
        name: 'calendarMain',
        component: () => import('@/views/operations/MainEventWrapper.vue'),
      },
      {
        path: '/operations/calendar/event-management/:id?',
        name: 'calendarEventManagement',
        component: () =>
          import('@/views/operations/EventManagementWrapper.vue'),
      },
    ],
  },
];
